import { FormControl, Input } from '@atlas-design-system/react';
import { useEffect, useState, useRef } from 'react';

export function EditableCell(props) {
    let { getValue, row: { index }, column, table, recordId } = props;
    const editableRowIndex = table.options.editableRowIndex;
    const initialValue = getValue();

    return index === editableRowIndex ? (
        <EditInput initialValue={initialValue} table={table} index={index} column={column} recordId={recordId} />
    ) : (<span>{initialValue}</span>)
}

function validateCell(column, currentCellRecord, source) {
    var v = currentCellRecord.value;
    if (column.columnDef.required && !(typeof v === 'string' && v.trim().length > 0)) {
        currentCellRecord.error = "This field is required";
    } else if (column.columnDef.regEx && !(!column.columnDef.regEx || column.columnDef.regEx.test(v))) {
        currentCellRecord.error = column.columnDef.regExMessage;
    } else {
        currentCellRecord.error = '';
    }
    currentCellRecord.isValid = !currentCellRecord.error;
    //update source
    source.splice(source.findIndex(r => r.id === column.id), 1, currentCellRecord);
}

function EditInput(props) {
    const { initialValue, table, index, column, recordId } = props;

    var id = column.id;
    // We need to keep and update the state of the cell normally
    const [value, setValue] = useState(initialValue)
    const [error, setError] = useState('')

    useEffect(() => {
        firstInputRef.current?.focus();
        if (table.options.meta.cellsValidationData.length === 0)
            table.options.meta.cellsValidationData = table.getAllColumns().reduce((acc, col) => {
                if (col.columnDef.editable)
                    acc.push({ value: '', id: col.id, error: '' });
                return acc;
            }, [])
        //update related cellsValidationData value by id from initialValue
        var currentCellRecord = table.options.meta.cellsValidationData.find(r => r.id === id);
        currentCellRecord.value = initialValue;
        onValueChange(initialValue);
        onBlur();
    }, []);

    // When the input is blurred, we'll call our table meta's updateData function
    const onBlur = () => {
        var currentRecord = { ...table.options.meta.unsavedRecord };
        var d = table.options.data[index];
        if (currentRecord.hasOwnProperty(recordId) && currentRecord[recordId] === d[recordId]) {
            table.options.meta.unsavedRecord = { ...currentRecord, [id]: value }
        } else {
            table.options.meta.unsavedRecord = { ...d, [id]: value }
        }
    }

    const onValueChange = (v) => {
        var currentCellRecord = { ...table.options.meta.cellsValidationData.find(r => r.id === id) };
        currentCellRecord.value = v;
        validateCell(column, currentCellRecord, table.options.meta.cellsValidationData);
        setValue(v);
        if (currentCellRecord.error !== error) {
            setError(currentCellRecord.error);
        }
        // const isRowValid = table.options.meta.cellsValidationData.every(a => !a.error);
        // if (table.options.meta.saveEditButtonStatus !== isRowValid)
        //     table.options.meta.setSaveEditButtonStatus(isRowValid)
    }

    const firstInputRef = useRef(null);
    const firstEditableId = table.getAllColumns().find(a => a.columnDef.editable)?.id;
    const itemProps = column.id === firstEditableId ? { ref: firstInputRef } : {};

    return (
        <FormControl hideLabel label="" error={error} isRequired={column.columnDef.required === true}>
            <Input
                autocomplete="off"
                value={value}
                type="text"
                onChange={e => onValueChange(e.target.value.toUpperCase())}
                onBlur={onBlur}
                onKeyDown={e => {
                    if (e.key === 'Enter') {
                        onBlur();
                        table.options.meta.updateRecord(index);
                    }
                }}
                {...itemProps}
            />
        </FormControl>
    )
}